import { useUIStore, type ToastAction } from '@/stores/ui';

interface ToastOptions {
  body?: string;
  action?: ToastAction;
  durationMs?: number;
}

export function useToast() {
  const push = useUIStore((s) => s.pushToast);
  return {
    success: (title: string, bodyOrOpts?: string | ToastOptions) =>
      push({ variant: 'success', title, ...normalize(bodyOrOpts) }),
    error: (title: string, bodyOrOpts?: string | ToastOptions) =>
      push({ variant: 'error', title, ...normalize(bodyOrOpts) }),
    info: (title: string, bodyOrOpts?: string | ToastOptions) =>
      push({ variant: 'info', title, ...normalize(bodyOrOpts) }),
    warning: (title: string, bodyOrOpts?: string | ToastOptions) =>
      push({ variant: 'warning', title, ...normalize(bodyOrOpts) }),
  };
}

function normalize(input?: string | ToastOptions): ToastOptions {
  if (input == null) return {};
  if (typeof input === 'string') return { body: input };
  return input;
}
